import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from "react";
import { getStaticResource } from '../../../api/developer';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import ReactMarkdown from 'react-markdown'
import BILLoader from '../../components/BILLoader/BILLoader';
import remarkGfm from 'remark-gfm'
import rehypeHighlight from 'rehype-highlight'

import "highlight.js/styles/github.css";
import './reactMarkdown.css';
import './index.css';

const useStyles = makeStyles((theme) => ({

  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
  }
}));

const BulkFaq = (props) => {

  const classes = useStyles();
  const { faqConfig } = props;
  const [content, setContent] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [isDisplayedContentLoading, setDisplayedContentLoading] = useState(true);
  const [displayedContent, setDisplayContent] = useState("");

  useEffect(() => {
    getStaticResource(faqConfig)
      .then((res) => setContent(res.data))
      .finally(() => setTimeout(() => { setLoading(false) }, 700))
  }, []);

  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel, question) => (event, isExpanded) => {

    getStaticResource(question.R)
      .then((res) => setDisplayContent(res.data))
      .finally(() => {
        setDisplayedContentLoading(false)
        setExpanded(isExpanded ? panel : false);
      })
  };

  if (isLoading) {

    return (
      <div className="intl-spinner-container">
        <BILLoader />
      </div>
    )
  }

  return (
    <div className="bulk-faq-container">
      <Card className={classes.root}>
        <div className={classes.details}>
          <CardContent className={classes.content}>
            <Typography style={{
              fontSize: "25px", fontWeight: "300", marginTop: "20px", marginBottom: "-12px", color: "#702fa8", fontFamily: "OpenSans,sans-serif",
              textRendering: "geometricPrecision"
            }}>FAQ</Typography>
            <hr style={{ width: "2%", borderTop: "3px solid", borderColor: "#05C3DE", marginBottom: "10px", marginLeft: "0" }} />
            <br />
            <div className={classes.rootAccordion}>
              {
                Object.values(content).map((question, index) => {
                  return (
                    <Accordion key={`accordion-${index}`} TransitionProps={{ unmountOnExit: true }} expanded={expanded === `panel${index}`} onChange={handleChange(`panel${index}`, question)} 
                    style={{
                      boxShadow: "0 0 4px 1px rgb(0 0 0 / 12%)",
                    }}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel${index}bh-content`}
                        id={`panel${index}bh-header`}
                      >
                        <Typography className={classes.heading}><b>{question.Q}</b></Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography variant="subtitle1" color="textSecondary">
                          {isDisplayedContentLoading ? 
                          
                          null

                          :
                            <div className='table-container'>
                              <ReactMarkdown
                                children={displayedContent}
                                rehypePlugins={[rehypeHighlight]}
                                remarkPlugins={[remarkGfm]}
                                components={{
                                  h3: ({node, ...props}) => <i style={{fontSize: '15px', lineHeight: 4, fontStyle: 'normal', fontWeight: '600'}} {...props} />,
                                }}
                              />
                            </div>
                          }
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  )
                })
              }
            </div>
          </CardContent>
        </div>
      </Card>
    </div>
  );
}

export default BulkFaq;